export default "__VITE_ASSET__e9c32f89__"